import * as fromRouter from '@ngrx/router-store'
import { LoginTokenModel } from '../api/identity/models/login-token-model'
import { RouterStateUrl } from '../app.routing'

import * as auth from '../shared/auth/store/reducers/auth.reducer'
import * as user from '../shared/auth/store/reducers/user.reducer'
import * as team from '../shared/team/store/reducers/team.reducer'
import * as conversationTeam from '../shared/team/store/reducers/conversation-team.reducer'
import * as users from '../shared/team/store/reducers/users.reducer'
import * as members from '../shared/team/store/reducers/members.reducer'
import * as loginPage from '../shared/auth/store/reducers/login-page.reducer'
import * as signal from '../shared/signalR/store/reducers/signalR.reducer'
import * as menu from '../shared/navbar/menu/store/reducers/menu.reducer'

/**
 * Created by sange on 15/08/2017.
 */

export interface AppState {
  auth: LoginTokenModel,
  user: user.State,
  loginPage: loginPage.State,
  team: team.State,
  conversationTeam: conversationTeam.State,
  users: users.State,
  members: members.State,
  signal: signal.State,
  routerReducer: fromRouter.RouterReducerState<RouterStateUrl>,
  menu: menu.State
}

export const appReducers = {
  auth: auth.reducer,
  user: user.reducer,
  loginPage: loginPage.reducer,
  team: team.reducer,
  conversationTeam: conversationTeam.reducer,
  users: users.reducer,
  members: members.reducer,
  signal: signal.reducer,
  routerReducer: fromRouter.routerReducer,
  menu: menu.reducer,
}

export const initialAppState: AppState = {
  auth: auth.initialState,
  user: user.initialState,
  loginPage: loginPage.initialState,
  team: team.initialState,
  conversationTeam: conversationTeam.initialState,
  users: users.initialState,
  members: members.initialState,
  signal: signal.initialState,
  routerReducer: null,
  menu: menu.initialState,
}



// WEBPACK FOOTER //
// ./src/app/store/app.state.ts